import {MARK_COMPLETED, UNDO_COMPLETED, RECEIVED_CHECKLISTS} from "./constants";

export function receivedChecklists(checklists){
   return {
      type: RECEIVED_CHECKLISTS, 
      checklists
   }
}

export function markComplete(id, date){
  return {
    type: MARK_COMPLETED, 
    id,
    date
  }
}

export function undoComplete(id, date){
   return {
     type: UNDO_COMPLETED, 
     id, 
     date
   }
}
